import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import FormRequest from '../common/formRequest';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FiscoService } from 'src/app/app-core/services/fisco.service';
import { alvaraFormEnum } from 'src/app/Enums/SpecificFormInputEnum';
import { EnderecoFormComponent } from 'src/app/components/endereco-form/endereco-form.component';
import { GenericValidator } from '../utilities/genericValidator';
import { UserDataRequestService } from 'src/app/app-core/services/user-data-request.service';
import { CnaeService } from 'src/app/app-core/services/cnae.service';
import { LocalStorageService } from 'src/app/app-core/services/local-storage.service';

@Component({
    selector: 'app-form-request-alvara',
    templateUrl: './form-request-alvara.component.html',
    styleUrls: ['./form-request-alvara.component.scss'],
    providers: [LocalStorageService]
})
export class FormRequestAlvaraComponent extends FormRequest implements OnInit, OnChanges, AfterViewInit {

    @ViewChild(EnderecoFormComponent) enderecoFormComponent: EnderecoFormComponent;
    @ViewChild('enderecoImovelFormComponent') enderecoImovelFormComponent: any;
    @ViewChildren(EnderecoFormComponent) enderecoForms: QueryList<EnderecoFormComponent>;

    @Input() applicantDetails;
    @Input() subject;

    public listRequestAlvara = [
        alvaraFormEnum.SOLICITACAO_ALTERACAO_CADASTRAL_REGULARIZACAO_ALVARA,
        alvaraFormEnum.SOLICITACAO_INSCRICAO_MUNICIPAL_EXPEDICAO_ALVARA
    ];

    public subjectChangedOnce = false;
    public alvaraFormEnum = alvaraFormEnum;

    public requiredFieldsRequests = [
        'SOLAL_Nome',
        'SOLAL_CPF',
        'SOLAL_SubstitutoTributario',
        'SOLAL_Telefone',
        'SOLAL_Email',

        'SOLAL_UF',
        'SOLAL_Municipio',
        'SOLAL_Logradouro',
        'SOLAL_Numero',
        'SOLAL_Bairro',
        'SOLAL_CEP',

        'SOLAL_InicioAtividadeRFB',
        'SOLAL_AreaTotal',

        'SOLAL_ContabilNome',
        'SOLAL_ContabilCPFCNPJ',
        'SOLAL_ContabilCRC',

        'SOLAL_ResponsavelNome',
        'SOLAL_ResponsavelCPF',
        'SOLAL_ResponsavelQualificacao',

        'SOLAL_ImovelUF',
        'SOLAL_ImovelMunicipio',
        'SOLAL_ImovelLogradouro',
        'SOLAL_ImovelNumero',
        'SOLAL_ImovelBairro',
        'SOLAL_ImovelCEP'
    ];

    public meiOptionalFields = [
        'SOLAL_SubstitutoTributario',
        'SOLAL_InscricaoMunicipal',
        'SOLAL_InicioAtividadeMunicipio',
        'SOLAL_InicioAtividadeRFB',
        'SOLAL_ContabilNome',
        'SOLAL_ContabilCPFCNPJ',
        'SOLAL_ContabilCRC'
    ];

    private localStorageKey = 'form-request-alvara';

    constructor(
        public fb: FormBuilder,
        public fiscoService: FiscoService,
        private userDataRequestService: UserDataRequestService,
        private cnaeService: CnaeService,
        private elementRef: ElementRef,
        private localStorageService: LocalStorageService,
    ) {
        super(fb, fiscoService);
    }

    ngOnInit(): void {
        this.initForm();
        this.formChanges();
        this.getFromLocalStorage();
        this.watchFormChanges();

        this.userDataRequestService.getRequerente().subscribe(requerente => {
            this.changeDataRequester(requerente);
        });
    }

    ngAfterViewInit(): void {
        this.syncEnderecoFormsWithDraft();
    }

    private syncEnderecoFormsWithDraft(): void {
        this.enderecoFormComponent?.patchInitialValue({
            uf: this.form.get('SOLAL_UF')?.value,
            localidade: this.form.get('SOLAL_Municipio')?.value,
            logradouro: this.form.get('SOLAL_Logradouro')?.value,
            numero: this.form.get('SOLAL_Numero')?.value,
            complemento: this.form.get('SOLAL_Complemento')?.value,
            bairro: this.form.get('SOLAL_Bairro')?.value,
            CEP: this.form.get('SOLAL_CEP')?.value,
        });

        this.enderecoImovelFormComponent?.patchInitialValue({
            uf: this.form.get('SOLAL_ImovelUF')?.value,
            localidade: this.form.get('SOLAL_ImovelMunicipio')?.value,
            logradouro: this.form.get('SOLAL_ImovelLogradouro')?.value,
            numero: this.form.get('SOLAL_ImovelNumero')?.value,
            complemento: this.form.get('SOLAL_ImovelComplemento')?.value,
            bairro: this.form.get('SOLAL_ImovelBairro')?.value,
            CEP: this.form.get('SOLAL_ImovelCEP')?.value,
        });
    }

    private watchFormChanges(): void {
        this.form.valueChanges.subscribe(() => {
            this.localStorageService.set(this.localStorageKey, this.form.getRawValue());
        });
    }

    private getFromLocalStorage(): void {
        const storageData = this.localStorageService.get<any>(this.localStorageKey);

        if (!storageData || typeof storageData !== 'object') return;

        // atividades/socios são FormArray: patchValue não cria itens extras, restaurados à parte
        const { atividades, socios, ...rest } = storageData;

        this.form.patchValue(rest);
        this.restoreAtividadesFromDraft(atividades);
        this.restoreSociosFromDraft(socios);
    }

    private restoreAtividadesFromDraft(atividadesDraft: any[]): void {
        if (!Array.isArray(atividadesDraft) || atividadesDraft.length === 0) return;

        this.atividades.clear();
        atividadesDraft.forEach(item => {
            const atividade = this.createAtividade();
            atividade.patchValue(item);
            this.atividades.push(atividade);
        });
    }

    private restoreSociosFromDraft(sociosDraft: any[]): void {
        if (!Array.isArray(sociosDraft) || sociosDraft.length === 0) return;

        this.socios.clear();
        sociosDraft.forEach(item => this.socios.push(this.fb.group({
            SOLAL_SocioCPFCNPJ: [item.SOLAL_SocioCPFCNPJ, [Validators.required, GenericValidator.isValidCpfOrCnpj()]],
            SOLAL_SocioNome: [item.SOLAL_SocioNome, Validators.required]
        })));
    }

    public clearLocalStorage(): void {
        this.localStorageService.remove(this.localStorageKey);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.subject && this.subjectChangedOnce) {
            this.resetFormGroupsBySubject();
        } else {
            this.subjectChangedOnce = true;
        }
    }

    initForm() {
        this.renderForm();

        if (this.haveSubject([alvaraFormEnum.SOLICITACAO_INSCRICAO_MUNICIPAL_EXPEDICAO_ALVARA])) {
            this.setValidatorsForm(this.requiredFieldsRequests);
        }

        if (this.haveSubject([alvaraFormEnum.SOLICITACAO_ALTERACAO_CADASTRAL_REGULARIZACAO_ALVARA])) {
            this.setValidatorsForm([
                ...this.requiredFieldsRequests,
                'SOLAL_InicioAtividadeMunicipio'
            ]);
        }
    }

    renderForm() {
        this.form = this.fb.group({
            SOLAL_Nome: [''],
            SOLAL_CPF: ['', [Validators.required, GenericValidator.isValidCpfOrCnpj()]],
            SOLAL_SouMEI: [false],
            SOLAL_SubstitutoTributario: ['NAO', Validators.required],
            SOLAL_InscricaoMunicipal: [''],
            SOLAL_Telefone: ['', [Validators.required, GenericValidator.isValidTelefone()]],
            SOLAL_Email: ['', [Validators.required, Validators.email]],
            SOLAL_InicioAtividadeMunicipio: [''],
            SOLAL_InicioAtividadeRFB: ['', Validators.required],
            
            SOLAL_UF: [''],
            SOLAL_Municipio: [''],
            SOLAL_Logradouro: [''],
            SOLAL_Numero: [''],
            SOLAL_Bairro: [''],
            SOLAL_Complemento: [''],
            SOLAL_CEP: [''],
            
            SOLAL_InscricaoIPTU: [''],
            SOLAL_AreaTotal: [null, Validators.required],
            
            SOLAL_ImovelUF: [''],
            SOLAL_ImovelMunicipio: [''],
            SOLAL_ImovelLogradouro: [''],
            SOLAL_ImovelNumero: [''],
            SOLAL_ImovelBairro: [''],
            SOLAL_ImovelComplemento: [''],
            SOLAL_ImovelCEP: [''],
            
            atividades: this.fb.array([
                this.createAtividade()
            ]),
            
            SOLAL_ContabilNome: ['', Validators.required],
            SOLAL_ContabilCPFCNPJ: ['', [Validators.required, GenericValidator.isValidCpfOrCnpj()]],
            SOLAL_ContabilCRC: ['', Validators.required],
            
            socios: this.fb.array([]),
            
            SOLAL_ResponsavelNome: ['', Validators.required],
            SOLAL_ResponsavelCPF: ['', [Validators.required, GenericValidator.isValidCpfOrCnpj()]],
            SOLAL_ResponsavelQualificacao: ['', Validators.required],
            
            formVariants: this.fb.group({
                SOL_Descricao: ['', Validators.required],
                termCheck: [false, Validators.requiredTrue]
            })
        });
    }

    private resetFormGroupsBySubject() {
        if (this.enderecoFormComponent) {
            this.enderecoFormComponent.reset();
        }
        if (this.enderecoImovelFormComponent) {
            this.enderecoImovelFormComponent.reset();
        }
        this.form.patchValue(this.fb.group({}));
        this.initForm();
        this.form.updateValueAndValidity();
        this.formChanges();
        this.changeDataRequester();
        // this.form é uma instância nova (criada em renderForm): a subscrição de salvamento
        // anterior ficou presa ao form antigo
        this.watchFormChanges();
    }

    private setValidatorsForm(list: string[]) {
        for (const field of list) {
            const control = this.form.get(field);
            if (control) {
                // addValidators preserva as validações de formato (CPF/CNPJ, e-mail, telefone)
                // declaradas em renderForm, que o setValidators anterior descartava
                if (!control.hasValidator(Validators.required)) {
                    control.addValidators(Validators.required);
                    control.updateValueAndValidity();
                }
            }
        }
    }

    getAddressAlvaratData(event) {
        this.form?.patchValue({
            SOLAL_Municipio: event.localidade,
            SOLAL_Bairro: event.bairro,
            SOLAL_Logradouro: event.logradouro,
            SOLAL_UF: event.uf,
            SOLAL_Numero: event.numero,
            SOLAL_Complemento: event.complemento,
            SOLAL_CEP: event.CEP
        });
        this.form.updateValueAndValidity();
    }

    getAddressImovelData(event) {
        this.form?.patchValue({
            SOLAL_ImovelMunicipio: event.localidade,
            SOLAL_ImovelBairro: event.bairro,
            SOLAL_ImovelLogradouro: event.logradouro,
            SOLAL_ImovelUF: event.uf,
            SOLAL_ImovelNumero: event.numero,
            SOLAL_ImovelComplemento: event.complemento,
            SOLAL_ImovelCEP: event.CEP
        });
        this.form.updateValueAndValidity();
    }

    get atividades() {
        return this.form.get('atividades') as FormArray;
    }

    get socios() {
        return this.form.get('socios') as FormArray;
    }

    createAtividade(): FormGroup {
        const atividade = this.fb.group({
            SOLAL_CNAE: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(9),
                    Validators.pattern(/^[0-9]{9}$/)
                ]
            ],

            SOLAL_DescricaoAtividade: ['', Validators.required],

            SOLAL_EspecieContribuinte: ['', Validators.required],

            SOLAL_TipoTributacao: ['', Validators.required],

            cnaeList: []
        }, {
            validators: this.cnaeValidator
        });

        atividade.get('SOLAL_CNAE')?.valueChanges.subscribe((value) => {
            if (value && value.length >= 1) {
                this.cnaeService.searchCnae(value).subscribe((result: any[]) => {
                    atividade.get('cnaeList')?.setValue(result);
                });
            }
        });

        if (this.form?.get('SOLAL_SouMEI')?.value) {
            this.setAtividadeMeiValidators(atividade, false);
        }

        return atividade;
    }

    private setAtividadeMeiValidators(
        atividade: FormGroup,
        required: boolean
    ): void {
        const especieContribuinte = atividade.get('SOLAL_EspecieContribuinte');
        const tipoTributacao = atividade.get('SOLAL_TipoTributacao');

        if (required) {
            especieContribuinte?.setValidators(Validators.required);
            tipoTributacao?.setValidators(Validators.required);
        } else {
            especieContribuinte?.clearValidators();
            tipoTributacao?.clearValidators();
        }

        especieContribuinte?.updateValueAndValidity({ emitEvent: false });
        tipoTributacao?.updateValueAndValidity({ emitEvent: false });
    }

    onMeiChange(event: any): void {
        const isMei = event.target.checked;

        const requiredFields = [
            'SOLAL_SubstitutoTributario',
            'SOLAL_InscricaoMunicipal',
            'SOLAL_InicioAtividadeMunicipio',
            'SOLAL_InicioAtividadeRFB',
            'SOLAL_ContabilNome',
            'SOLAL_ContabilCPFCNPJ',
            'SOLAL_ContabilCRC'
        ];

        requiredFields.forEach(field => {
            const control = this.form.get(field);

            if (!control) {
                return;
            }

            if (isMei) {
                switch (field) {
                    case 'SOLAL_ContabilCPFCNPJ':
                        control.setValidators(
                            GenericValidator.isValidCpfOrCnpj()
                        );
                        break;

                    default:
                        control.clearValidators();
                        break;
                }
            } else {
                this.restoreFieldValidator(field, control);
            }

            control.updateValueAndValidity({ emitEvent: false });
        });

        this.atividades.controls.forEach((atividade: FormGroup) => {
            this.setAtividadeMeiValidators(atividade, !isMei);
        });

        this.form.updateValueAndValidity();
    }

    private restoreFieldValidator(
        field: string,
        control: any
    ): void {
        switch (field) {
            case 'SOLAL_SubstitutoTributario':
                control.setValidators(Validators.required);
                break;

            case 'SOLAL_InscricaoMunicipal':
                control.clearValidators();
                break;

            case 'SOLAL_InicioAtividadeMunicipio':
                if (
                    this.haveSubject([
                        alvaraFormEnum.SOLICITACAO_ALTERACAO_CADASTRAL_REGULARIZACAO_ALVARA
                    ])
                ) {
                    control.setValidators(Validators.required);
                } else {
                    control.clearValidators();
                }
                break;

            case 'SOLAL_InicioAtividadeRFB':
                control.setValidators(Validators.required);
                break;

            case 'SOLAL_ContabilNome':
                control.setValidators(Validators.required);
                break;

            case 'SOLAL_ContabilCPFCNPJ':
                control.setValidators([
                    Validators.required,
                    GenericValidator.isValidCpfOrCnpj()
                ]);
                break;

            case 'SOLAL_ContabilCRC':
                control.setValidators(Validators.required);
                break;

            default:
                break;
        }
    }

    private cnaeValidator(group: FormGroup) {
        const numero = group.get('SOLAL_CNAE')?.value;
        const descricao = group.get('SOLAL_DescricaoAtividade')?.value;
    
        if (numero && descricao) {
            return null;
        }
    
        return { cnaeIncompleto: true };
    }

    limitCnaeLength(event: any, index: number) {
        const value = event.target.value.replace(/\D/g, '').slice(0, 9);
        this.atividades.at(index).get('SOLAL_CNAE')?.setValue(value, { emitEvent: false });
    }

    onSelectCnae(cnae, index: number) {
        const atividade = this.atividades.at(index);

        atividade.patchValue({
            SOLAL_CNAE: cnae.CNAE_Numero,
            SOLAL_DescricaoAtividade: cnae.CNAE_Descricao
        });
    }

    addAtividade(): void {
        this.atividades.push(this.createAtividade());
    }

    removeAtividade(index: number): void {
        if (this.atividades.length > 1) {
            this.atividades.removeAt(index);
        }
    }

    createSocio(): FormGroup {
        return this.fb.group({
            SOLAL_SocioCPFCNPJ: ['', [Validators.required, GenericValidator.isValidCpfOrCnpj()]],
            SOLAL_SocioNome: ['', Validators.required]
        });
    }

    addSocio(): void {
        this.socios.push(this.createSocio());
    }

    removeSocio(index: number): void {
        this.socios.removeAt(index);
    }

    public changeDataRequester(requerente?: any) {
        if (requerente) {
            this.form?.patchValue({
                SOLAL_CPF: requerente.SOLR_CpfCnpj,
                SOLAL_Nome: requerente.SOLR_NomeRazaoSocial,
                SOLAL_Email: requerente.SOLR_Email,
                SOLAL_Telefone: requerente.SOLR_Telefone
            });
    
            this.disabledFields(['SOLAL_CPF', 'SOLAL_Nome', 'SOLAL_Email', 'SOLAL_Telefone']);
        } else if (this.applicantDetails) {
            this.form?.patchValue({
                SOLAL_CPF: this.applicantDetails.SOLR_CpfCnpj,
                SOLAL_Nome: this.applicantDetails.SOLR_NomeRazaoSocial
            });
    
            this.disabledFields(['SOLAL_CPF', 'SOLAL_Nome']);
        }
    
        this.form.updateValueAndValidity();
    }

    public disabledFields(fields: string[]) {
        fields.forEach(field => {
            const control = this.form.get(field);
            if (control) {
                control.disable();
            }
        });
    }

    /**
     * Marca todos os campos (inclusive os dos endereços) como tocados para que os obrigatórios
     * vazios fiquem destacados, e rola até o primeiro inválido. Retorna se o formulário é válido.
     */
    public validateBeforeProceed(): boolean {
        const enderecos = this.enderecoForms ? this.enderecoForms.toArray() : [];

        this.form.markAllAsTouched();
        enderecos.forEach(endereco => endereco.form.markAllAsTouched());

        if (this.form.valid && enderecos.every(endereco => endereco.form.valid)) {
            return true;
        }

        this.scrollToFirstInvalidField();

        return false;
    }

    /**
     * Leva o contribuinte até o primeiro campo sinalizado, independentemente do tipo do campo.
     */
    private scrollToFirstInvalidField(): void {
        setTimeout(() => {
            const firstInvalid: HTMLElement = this.elementRef.nativeElement.querySelector(
                '[formControlName].ng-invalid.ng-touched:not([disabled]):not([readonly])'
            );

            if (!firstInvalid) {
                return;
            }

            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });

            const focusable: HTMLElement = firstInvalid.matches('input, select, textarea')
                ? firstInvalid
                : firstInvalid.querySelector('input, select, textarea');

            if (focusable) {
                focusable.focus({ preventScroll: true });
            }
        });
    }

    onSubstitutoChange(valor: 'SIM' | 'NAO') {
        this.form.get('SOLAL_SubstitutoTributario')?.setValue(valor);
    }
}

